module.exports = __webpack_public_path__ + "img/sign.94b4fd8.svg";